
const lodash = require('lodash')

const configApps = process.env.VUE_APP_DOMAINS.split(',')
const configMode = process.env.VUE_APP_MODE.split(',')
// Для дебага разных типов приложений верхние строчки комментируем, нижние - расскоментируем и меняем их прямо на горячую...
// const configApps = ['mik'] // возможные значения: 'mik' | 'doc'
// const configMode = ['prod', 'demo'] // возможные значения: 'prod' | 'demo'

export function isCurrentAppIn (apps) {
  return lodash.intersection(apps, configApps).length > 0
}

export function isDocApplication () {
  return configApps.includes('doc')
}

export function isMikApplication () {
  return configApps.includes('mik')
}

export function isDemoAvailable () {
  return configMode.includes('demo')
}

export function isProdAvailable () {
  return configMode.includes('prod')
}
